import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import {
  getDownloadEmployeesImportsTemplateCall,
  postEmployeesImportsTemplateCall,
  getEmployeesImportsByJobIdCall,
  getEmployeesImportsStatsCall,
  getEmployeesImportCall,
  putEmployeesImportCall,
  getEmployeesCall,
  getUnassignedEmployeesCall,
  getEmployeesStatsCall,
  getEmployerByIdCall,
  putEmployerByIdCall,
  postEmployeesImportsConfirmCall,
  getEmployeesFiltersCall,
  postEmployerByIdEnableCall,
  postEmployerByIdDisableCall,
  deleteEmployerByIdCall,
  getEmployeesImportsOverviewCall,
  postEmployeesImportsAbortCall,
  postEmployeesImportsAbortByJobIdCall,
  postEmployeesDeleteCheckCall,
  postEmployeeCall,
  postEmailAlreadyExistCall,
} from './api';

type sagaIteratorFunction = () => SagaIterator;

export const allSagas: sagaIteratorFunction[] = [
  getDownloadEmployeesImportsTemplateCall.saga,
  postEmployeesImportsTemplateCall.saga,
  getEmployeesImportsByJobIdCall.saga,
  getEmployeesImportsStatsCall.saga,
  getEmployeesImportCall.saga,
  putEmployeesImportCall.saga,
  getEmployeesStatsCall.saga,
  getEmployeesCall.saga,
  getUnassignedEmployeesCall.saga,
  getEmployerByIdCall.saga,
  putEmployerByIdCall.saga,
  postEmployeesImportsConfirmCall.saga,
  getEmployeesFiltersCall.saga,
  postEmployerByIdEnableCall.saga,
  postEmployerByIdDisableCall.saga,
  deleteEmployerByIdCall.saga,
  getEmployeesImportsOverviewCall.saga,
  postEmployeesImportsAbortCall.saga,
  postEmployeesImportsAbortByJobIdCall.saga,
  postEmployeesDeleteCheckCall.saga,
  postEmployeeCall.saga,
  postEmailAlreadyExistCall.saga,
];

export function* peopleSaga(): SagaIterator {
  yield all(allSagas.map((s: sagaIteratorFunction) => fork(s)));
}
